import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AutorunComponent } from '@myshared/autorun.component';
import { Model } from '../../../app.model';
import { Customer } from '../../../customer/customer.model';
import {Country} from "../../../country/country.model";
import {FormEmitter} from "../../../forms/form.component";

@Component({
    selector: 'app-select-customer-create',
    templateUrl: './select-customer-create.component.html',
    standalone: false
})
export class SelectCustomerCreateComponent extends AutorunComponent implements OnInit {

  public customers: Customer[];

  @Output() public createCustomer = new EventEmitter<Customer>();

  public countries: Country[] = [];

  constructor(private m: Model) {
    super();
  }

  ngOnInit() {
      this.autorun(() => {
        this.countries = this.m.country.countries;
      });
  }

  onCreate(form: FormEmitter<Customer>) {
    this.createCustomer.emit(form.data);
  }

}
